export const handleFilterButtonClick = () => {

    const button = document.querySelector('.js-button__filter');
    if (!button) {
        return;
    }
    const filter = document.querySelector('#sidebar')
    if (!filter) {
        return;
    }

    const filterInner = document.querySelector('#sidebar .inner')
    if (!filterInner) {
        return;
    }

    const header = document.querySelector('#header-outer');

    const closeButton = document.createElement('button');
    closeButton.classList.add('filter--close', 'button');
    closeButton.innerHTML = '<i class="fas fa-times"></i>';
    filterInner.appendChild(closeButton);

    button.addEventListener('click', () => {
        filter.classList.add('active');
        document.body.style.overflow = 'hidden'; // Block scrolling on body when filter is active.
        filter.style.top = heightInViewPort(header);

        closeButton.addEventListener('click', () => {
            filter.classList.remove('active');
            document.body.style.overflow = ''; // Reset scrolling on body when filter is closed.
        });
    });
}

function heightInViewPort(el) {
    const elementHeight = el.clientHeight;
    const rect = el.getBoundingClientRect();

    if (rect.top === 0) {
        return `${elementHeight}px`;
    }

    const availableHeight = Math.max(rect.bottom, 0);

    return `${availableHeight}px`;
}